import { type ReactNode } from 'react';

export const pointerIconClassName = 'mt-0.5 h-4 w-4 shrink-0 text-emerald-600 sm:h-5 sm:w-5';
export const pointerTextClassName = 'text-sm font-medium leading-snug text-gray-900';
export const insightHeadingClassName = 'text-sm sm:text-sm font-semibold leading-snug text-gray-900';
export const insightSubheroClassName = 'mt-1 w-full text-xs leading-snug text-gray-500';
export const highlightedNumberClassName = 'text-sm sm:text-base font-bold text-yellow-600';
export const subheroHighlightedNumberClassName = 'font-semibold text-gray-700';

interface InsightPointerProps {
  icon: ReactNode;
  children: ReactNode;
}

export default function InsightPointer({ icon, children }: InsightPointerProps) {
  return (
    <li className="flex w-max max-w-full items-start gap-2.5 sm:whitespace-nowrap">
      {icon}
      <span className={pointerTextClassName}>{children}</span>
    </li>
  );
}
